/* eslint-disable react-hooks/rules-of-hooks */
import Logger, { ILogger as ChargifyLogger } from 'js-logger';

Logger.useDefaults();

const consoleHandler = Logger.createDefaultHandler();

Logger.setHandler((messages, context) => {
  if (
    process.env.NODE_ENV !== 'test' &&
    process.env.NODE_ENV !== 'production'
  ) {
    consoleHandler(messages, context);
  }
});

export default Logger;
export type { ChargifyLogger };
